import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { Button, Typography } from '@material-ui/core';
import { useCategoriasInitialValue } from 'app/main/compra/components/modal/compraInitialValues';
import { cancelarAlert, simpleAlert } from 'app/services/alerts';
import { parametrosNotaFiscalApi } from 'app/services/api/parametrosNotaFiscalApi';
import { parametrosReceitaApi } from 'app/services/api/parametrosReceitaApi';
import { vendaApi } from 'app/services/api/vendaApi';
import * as Actions from 'app/store/actions';
import { FormikProvider, useFormik } from 'formik';
import React, { useContext, useEffect, useState } from 'react';
import { FaTags } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import * as yup from 'yup';
import { VendaContext } from '../../../VendaContext';
import { trataDadosFiscaisProduto } from '../../VendaProdutoServico/cadastro/atualizarAliquotaUtils';
import {
  useClienteInitialValue,
  useDataInitialValue,
  useDisableFaturarVendaContrato,
  useDisableUnificarCobrancaContratoVenda,
  useHabilitarDescontoInitialValue,
  useHabilitarFreteInitialValue,
  useHabilitarTipoDescontoInitialValue,
  useIdentificadorInitialValue,
  usePagamentoInitialValue,
  useProdutosServicosInitialValue,
  useVendedorInitialValue,
} from '../VendaInitialValues';
import { VendaModais } from '../VendaModais';
import VENDA_SCHEMA from '../VendaSchema';
import CadastroVendaForm from './CadastroVendaForm';
import SelecionarContrato from './SelecionarContrato';
import {
  normalizarServicoFiscalParaSalvar,
  possuiIbsCbsUtilizado,
} from '../../VendaProdutoServico/cadastro/servicoFiscalVendaUtils';
import { vendaFormStyles } from './styles';

const CadastroVendaModal = ({ onSubmit, modalSelecionarContratos, setModalSelecionarContratos }) => {
  const [venda] = useContext(VendaContext).vendaAtual;
  const [modal, setModal] = useContext(VendaContext).modal;
  const [search] = useContext(VendaContext).search;
  const [page] = useContext(VendaContext).page;
  const [size] = useContext(VendaContext).size;
  const [sort] = useContext(VendaContext).sort;

  const [enviarOrcamento, setEnviarOrcamento] = useState(false);
  const [municipioIncidencia, setMunicipioIncidencia] = useState();
  const [faturarContratoVendaJuntos, setFaturarContratoVendaJuntos] = useState(false);
  const [unificarCobrancaContratoVenda, setUnificarCobrancaContratoVenda] = useState(false);
  const [vendaRequest, setVendaRequest] = useState({});
  const [contratosVenda, setContratosVenda] = useState([]);

  const classes = vendaFormStyles();

  const dispatch = useDispatch();

  const showError = (message) => {
    dispatch(Actions.showMessage({ message, variant: 'error' }));
  };

  useEffect(() => {
    const buscarParametrosReceita = async () => {
      const resp = await parametrosReceitaApi().getParametrosReceitaEmpresa();
      setFaturarContratoVendaJuntos(resp?.data?.faturarContratoVendaJuntos);
      setUnificarCobrancaContratoVenda(resp?.data?.unificarCobrancaContratoVenda);
    };
    buscarParametrosReceita();
  }, []);

  const initialValues = {
    id: venda?.id || '',

    // Dados da venda
    identificador: useIdentificadorInitialValue(venda?.identificador),
    data: useDataInitialValue(venda?.data),
    cliente: useClienteInitialValue(venda?.cliente),
    categorias: useCategoriasInitialValue(venda),
    situacao: venda?.situacao,
    motivoVenda: venda?.motivoVenda || 'VENDA_PADRAO',
    vendedor: useVendedorInitialValue(venda?.vendedor),
    descricao: venda?.descricao,

    // Produtos e Serviços
    produtosServicos: useProdutosServicosInitialValue(venda?.produtosServicos),

    // Dados de entrega
    valorFrete: venda?.valorFrete || '',
    tipoDesconto: venda?.tipoDesconto || ' ',
    valorDesconto: venda?.valorDesconto || '',
    valorTotal: venda?.valorTotal || '',
    previsaoEntrega: venda?.previsaoEntrega,
    dataVencimentoOrcamento: venda?.dataVencimentoOrcamento,
    transportadora: venda?.transportadora,
    municipioIncidencia: venda?.municipioIncidencia || municipioIncidencia,

    // Pagamento
    pagamento: usePagamentoInitialValue(venda?.pagamento),
    vencimentoCobranca: venda?.vencimentoCobranca,
    formaRecebimento: venda?.formaRecebimento || 'BOLETO',

    // Informações complementares
    informacoesComplementares: venda?.informacoesComplementares || '',
    envioAutomaticoCobranca: venda?.envioAutomaticoCobranca || false,
    faturarContratoVendaJuntos: venda?.faturarContratoVendaJuntos ?? faturarContratoVendaJuntos,
    unificarCobrancaContratoVenda: venda?.unificarCobrancaContratoVenda ?? unificarCobrancaContratoVenda,
    enviarCobrancaEmail: venda?.enviarCobrancaEmail || false,
    enviarNotaFiscalEmail: venda?.enviarNotaFiscalEmail || false,
    emailsCliente: venda?.emailsCliente || [{ email: '', principal: true }],

    // Campos desabilitados
    habilitarFrete: useHabilitarFreteInitialValue(venda?.produtosServicos),
    habilitarTipoDesconto: useHabilitarTipoDescontoInitialValue(venda?.produtosServicos),
    habilitarDesconto: useHabilitarDescontoInitialValue(venda?.tipoDesconto),
    disableFaturarVendaContratoJuntos: useDisableFaturarVendaContrato(venda?.statusFaturamentoUnificado),
    disableUnificarCobrancaContratoVenda: useDisableUnificarCobrancaContratoVenda(venda?.situacaoCobrancaUnificada),
    vendaUnificada: venda?.faturarContratoVendaJuntos || venda?.unificarCobrancaContratoVenda,

    possuiNotaFiscalTransmitida: venda?.possuiNotaFiscalTransmitida,
    responsavelFrete: venda?.responsavelFrete || ' ',
    possuiCobrancaRegistrada: venda?.possuiCobrancaRegistrada,

    // Informacoes de integracao
    origemIntegracao: venda?.origemIntegracao,
    contratoContaReceberId: venda?.contratoContaReceberId,
  };

  const close = () => {
    formik.resetForm(initialValues);
    setModal('');
  };

  const calcularSubtotal = (produtoServico) => {
    if (produtoServico.subtotalCalculado != null && produtoServico.subtotalCalculado !== '') {
      return Number(produtoServico.subtotalCalculado);
    }
    const { valor, quantidade } = produtoServico;
    return (valor || 0) * (quantidade || 1);
  };

  const submitAndClose = async (venda) => {
    const res = await onSubmit(venda, { q: search, page, size, sort }, enviarOrcamento);
    setEnviarOrcamento(false);
    if (res) {
      close();
    }
  };

  const apenasUmContratoEncontrado = async (contratoContaReceberDto, venda) => {
    if (contratoContaReceberDto?.contratoContaReceberId) {
      if (venda.unificarCobrancaContratoVenda && contratoContaReceberDto?.situacao) {
        if (contratoContaReceberDto?.situacao === 'ABERTA') {
          cancelarAlert({
            opcoes: {
              title: 'Identificamos que já existe uma cobrança gerada para o contrato selecionado. Deseja unificar?',
              text: '',
            },
            confirmar: async () => {
              venda.contratoContaReceberId = contratoContaReceberDto.contratoContaReceberId;
              venda.excluirCobrancaJaGerada = true;
              await submitAndClose(venda);
            },
            cancelar: async () => {
              venda.excluirCobrancaJaGerada = false;
              venda.unificarCobrancaContratoVenda = false;
              if (venda.faturarContratoVendaJuntos) {
                venda.contratoContaReceberId = contratoContaReceberDto.contratoContaReceberId;
              }
              await submitAndClose(venda);
            },
          });
        } else if (contratoContaReceberDto?.situacao === 'BAIXADA' || contratoContaReceberDto?.situacao === 'PARCIAL') {
          cancelarAlert({
            opcoes: {
              title:
                'Identificamos que já existe uma cobrança gerada e baixada para o contrato selecionado. Deseja gerar apenas a cobrança da venda?',
              text: '',
            },
            confirmar: async () => {
              venda.unificarCobrancaContratoVenda = false;
              venda.excluirCobrancaJaGerada = false;
              if (venda.faturarContratoVendaJuntos) {
                venda.contratoContaReceberId = contratoContaReceberDto.contratoContaReceberId;
              }
              await submitAndClose(venda);
            },
          });
        }
      } else {
        venda.contratoContaReceberId = contratoContaReceberDto.contratoContaReceberId;
        vendaRequest.excluirCobrancaJaGerada = false;
        await submitAndClose(venda);
      }
    }
  };

  const vincularContrato = async (venda, contratoContaReceberIdJáVinculado) => {
    setVendaRequest(venda);
    try {
      let resp;
      if (!contratoContaReceberIdJáVinculado) {
        resp = await vendaApi().buscarContratosVenda(venda);
      } else {
        resp = await vendaApi().buscarContratoContaReceberVinculado(contratoContaReceberIdJáVinculado);
      }
      if (resp.data.length > 0) {
        // Apenas um contrato encontrado
        if (resp.data.length === 1) {
          apenasUmContratoEncontrado(resp.data[0], venda);
        } else {
          setContratosVenda(resp.data);
          setModalSelecionarContratos(true);
        }
      } else {
        if (venda.faturarContratoVendaJuntos) {
          simpleAlert({
            opcoes: {
              title:
                'Não foi possível faturar a venda junto com o contrato. Situação, cliente e competência devem ser iguais aos do contrato.',
            },
          });
        } else {
          simpleAlert({
            opcoes: {
              title:
                'Não foi possível unificar cobrança da venda com a do contrato. Situação, cliente, competência, data de vencimento e condição do pagamento devem ser iguais aos do contrato.',
            },
          });
        }
      }
    } catch (err) {
      if (err.response?.data?.errorKey === 'venda.sem.servicos') {
        simpleAlert({
          opcoes: {
            title: err.response?.data?.message,
          },
        });
      } else {
        showError('Erro ao vincular contrato: ' + err.message);
      }
    }
  };

  const handleSubmit = async (data = {}) => {
    if (!formik?.dirty && !venda?.isClone && !enviarOrcamento) {
      close();
      return;
    }

    const _venda = JSON.parse(JSON.stringify(data));

    // Verifica se existe algum valor negativo
    const vendaPossuiValorNegativo = _venda.produtosServicos.some((produtoServico) => {
      const valor = calcularSubtotal(produtoServico);
      if (valor < 0) {
        showError('Não é possível salvar a venda: o valor do subtotal de um dos serviços está negativo.');
        return true;
      }
      return false;
    });

    // Se não houver valores negativos, procede com a lógica de salvar
    if (!vendaPossuiValorNegativo) {
      if (_venda.situacao !== 'EM_ORCAMENTO') {
        delete _venda.dataVencimentoOrcamento;
      }

      _venda.categorias.map((categoria) => {
        categoria.classeId = categoria.classe.id;
        return categoria;
      });

      _venda.produtosServicos = _venda.produtosServicos.map((item) => {
        const { produtoServico, fiscal, servicoFiscal } = item;

        const isProduto = !!produtoServico?.produtoId;
        const isServico = !!produtoServico?.servicoId;
        const possuiIbsCbs = servicoFiscal ? possuiIbsCbsUtilizado(servicoFiscal) : false;

        return {
          ...item,
          produtoId: produtoServico?.produtoId || null,
          servicoId: produtoServico?.servicoId || null,
          fiscal: isProduto ? trataDadosFiscaisProduto(fiscal) : null,
          servicoFiscal: isServico
            ? normalizarServicoFiscalParaSalvar(servicoFiscal, possuiIbsCbs)
            : null,
        };
      });

      _venda.transportadoraId = _venda.transportadora?.id;
      delete venda.transportadora;

      _venda.vendedorId = _venda.vendedor?.id;
      delete _venda.vendedor;

      _venda.clienteId = _venda.cliente.id;
      delete _venda.cliente;

      if (_venda.pagamento.tipoPagamento === 'A_VISTA') {
        delete _venda.pagamento.parcelamento;
        delete _venda.pagamento.avista.tipoPagamento;
      } else {
        _venda.pagamento.parcelamento.parcelas = _venda.pagamento.parcelamento.parcelas.map(
          ({ id, receitaId, valorParcela, dataVencimento }) => ({
            id,
            receitaId,
            valor: valorParcela,
            dataVencimento,
          })
        );

        delete _venda.pagamento.avista;
        delete _venda.pagamento.parcelamento.tipoPagamento;
      }

      if (_venda.faturarContratoVendaJuntos || _venda.unificarCobrancaContratoVenda) {
        await vincularContrato(_venda, _venda?.contratoContaReceberId);
      } else {
        await submitAndClose(_venda);
      }
    }
  };

  const formik = useFormik({
    initialValues,
    onSubmit: handleSubmit,
    validateOnChange: true,
    validateOnBlur: true,
    validationSchema: () =>
      yup.lazy((values) => {
        switch (values.motivoVenda) {
          case 'VENDA_PADRAO':
            return VENDA_SCHEMA.VENDA_PADRAO;
          case 'VENDA_ENTREGA_FUTURA':
            return VENDA_SCHEMA.VENDA_FUTURA;
          case 'VENDA_A_ORDEM':
            return VENDA_SCHEMA.VENDA_ORDEM;
          default:
            return yup.mixed();
        }
      }),
  });

  useEffect(() => {
    buscarParametrosNF();
    formik.resetForm(initialValues);
    // Reset controlado pelo gatilho acima; incluir o formulário/valores reiniciaria o
    // preenchimento enquanto o usuário edita.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [venda]);

  const handleClose = () => {
    if (formik.dirty) {
      cancelarAlert({
        confirmar: close,
      });
    } else {
      close();
    }
  };

  const salvarEnviar = () => {
    setEnviarOrcamento(true);
    formik.handleSubmit(formik.values);
  };

  const buscarParametrosNF = async () => {
    try {
      const params = await parametrosNotaFiscalApi().getParametrosNotaFiscalEmpresa();
      setMunicipioIncidencia(params?.data?.municipioIncidencia);
    } catch (err) {
      console.log(err);
    }
  };

  const isEmOrcamento = formik?.values?.situacao === 'EM_ORCAMENTO';

  return (
    <SimpleDialog fullScreen open={modal === VendaModais.cadastrarVenda} onClose={handleClose} innerScroll>
      <FormikProvider value={formik}>
        <FormDialogContent
          onSubmit={formik.handleSubmit}
          fullScreen
          header={{
            title: 'Cadastro de venda',
            icon: <FaTags />,
            toolbar: (
              <>
                <CancelButton title="cancelar" type="button" onClick={handleClose}>
                  Cancelar
                </CancelButton>
                <SaveButton
                  color="buttonSave"
                  type="submit"
                  styles={isEmOrcamento ? classes.buttonSave : undefined}
                  variant={isEmOrcamento ? 'outlined' : 'contained'}
                >
                  Salvar
                </SaveButton>
                {isEmOrcamento && (
                  <Button
                    className={classes.buttonSalvarEnviar}
                    onClick={salvarEnviar}
                    variant="contained"
                    type="button"
                  >
                    <Typography style={{ margin: 0 }}>Salvar e enviar</Typography>
                  </Button>
                )}
              </>
            ),
          }}
          content={
            <div className="h-full max-h-full w-full">
              <CadastroVendaForm />
              <SelecionarContrato
                vendaRequest={vendaRequest}
                submitAndClose={submitAndClose}
                modalSelecionarContratos={modalSelecionarContratos}
                setModalSelecionarContratos={setModalSelecionarContratos}
                contratosVenda={contratosVenda}
                setContratosVenda={setContratosVenda}
                showError={showError}
              />
            </div>
          }
        />
      </FormikProvider>
    </SimpleDialog>
  );
};

export default CadastroVendaModal;
